import toast from 'react-hot-toast';
import { serverUrl } from 'app/constants';
import Clerk from "@clerk/clerk-react";
import Cookies from "js-cookie";

/**
 * Performs a generic GET request using the provided path and data.
 * The data parameter will be transformed into URL parameters.
 *
 * @param {string} path - The URL path for the GET request.
 * @param {object} data - The data object to be transformed into URL parameters.
 * @returns {Object} The parsed JSON response.
 * @throws {Error} If there is an error during the request.
 */
// prettier-ignore
export async function serverGet(path, data) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(data)) {
    params.append(key, value);
  }
  const paramsStr = params.toString();
  const url = `${serverUrl}${path}?${paramsStr}`;
  const token = await Cookies.get("__session")
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `${ token }`,
      },
    });
    if (response.status !== 200) {
      if (response.status === 403) {
        toast.error(`Please login to continue`);
      } else {
        toast.error(`Error ${ response.status }`);
      }
      const responseBody = await response.json();
      throw responseBody;
    } else {
        const responseBody = await response.json();
        return responseBody;
    }
  } catch (error) {
    toast.error(`Error ${ error.message }`);
    throw error;
  }
}

/**
 * Performs a generic POST request using the provided path and data.
 * The data parameter will be transformed into the request body.
 *
 * @param {string} path - The URL path for the GET request.
 * @param {object} data - The data object to be transformed into URL parameters.
 * @returns {Object} The parsed JSON response.
 * @throws {Error} If there is an error during the request.
 */
// prettier-ignore
export async function serverPost(path, data) {
    const url = `${serverUrl}${path}`;
    const token = await Cookies.get("__session")
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `${ token }`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      // Handle specific errors 
      if (response.status === 429) {
        const responseBody = await response.json();
        toast.error(responseBody.detail)
      } else if (response.status === 400) {
        const responseBody = await response.json();
        toast.error(responseBody.error)
        throw responseBody
      } else if (response.status !== 200) {
        toast.error(`Error ${ response.status }`);
        const responseBody = await response.json();
        throw responseBody;
      } else {
          const responseBody = await response.json();
          return responseBody;
      }
    } catch (error) {
      toast.error(`Error ${ error.message }`);
      throw error;
    }
  }

export async function serverPut(path, data) {
  const url = `${serverUrl}${path}`;
  const token = await Cookies.get("__session")
  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Authorization': `${ token }`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.status !== 200) {
      toast.error(`Error ${ response.status }`);
      const responseBody = await response.json();
      throw responseBody;
    } else {
      const responseBody = await response.json();
      return responseBody;
    }
  } catch (error) {
    toast.error(`Error ${ error.message }`);
    throw error;
  }
}

export async function serverDelete(path, data) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(data)) {
    params.append(key, value);
  }
  const paramsStr = params.toString();
  const url = `${serverUrl}${path}?${paramsStr}`;
  const token = await Cookies.get("__session")
  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Authorization': `${ token }`,
      },
    });
    if (response.status !== 200) {
      toast.error(`Error ${ response.status }`);
      const responseBody = await response.json();
      throw responseBody;
    } else {
      const responseBody = await response.json();
      return responseBody;
    }
  } catch (error) {
    toast.error(`Error ${ error.message }`);
    throw error;
  }
}